"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var hooks_1 = require("../../hooks");
var store_1 = require("../../store");
var Button_1 = __importDefault(require("../Button"));
var FormatText_1 = __importDefault(require("../FormatText"));
var Icon_1 = __importDefault(require("../Icon"));
var buildItems = function (path, menu) {
    for (var i = 0; i < menu.length; i += 1) {
        var result = buildItem(path, menu[i]);
        if (result)
            return result;
    }
    return undefined;
};
var buildItem = function (path, menuItem) {
    if (menuItem.uri && path == menuItem.uri) {
        return [menuItem.label];
    }
    if (menuItem.items) {
        var result = buildItems(path, menuItem.items);
        if (result) {
            result.unshift(menuItem.label);
            return result;
        }
    }
    return undefined;
};
var BreadcrumbBar = function (props) {
    var helpAreaCollapsed = store_1.useStore(function (state) { return state.ui.helpAreaCollapsed; });
    var guide = store_1.useStore(function (state) { return state.ui.guide; });
    var hasMasterArea = store_1.useStore(function (state) { return state.ui.hasMasterArea; });
    var workspaceToolbar = store_1.useStore(function (state) { return state.ui.workspaceToolbar; });
    var toggleMasterAreaCollapse = store_1.useActions(function (state) { return state.ui.toggleMasterAreaCollapse; });
    var toggleHelpAreaCollapse = store_1.useActions(function (state) { return state.ui.toggleHelpAreaCollapse; });
    var location = hooks_1.useRouter().location;
    var menu = props.menu;
    var items = react_1.useMemo(function () {
        if (location.pathname.indexOf('/detail') > 0) {
            return buildItems(location.pathname.substr(0, location.pathname.indexOf('/detail')), menu);
        }
        if (location.pathname.indexOf('/new') > 0) {
            return buildItems(location.pathname.substr(0, location.pathname.indexOf('/new')), menu);
        }
        return buildItems(location.pathname, menu);
    }, [location, menu]);
    return (react_1.default.createElement(antd_1.Row, { type: "flex", align: "middle" },
        react_1.default.createElement(antd_1.Col, { xs: 18, className: "ant-app-breadcrumb-container" },
            hasMasterArea && react_1.default.createElement(Icon_1.default, { className: "trigger", name: "games-xbox_menu", onClick: toggleMasterAreaCollapse }),
            react_1.default.createElement(antd_1.Breadcrumb, { separator: react_1.default.createElement(Icon_1.default, { name: "arrows-right_4" }) }, (items || []).map(function (item) { return (react_1.default.createElement(antd_1.Breadcrumb.Item, { key: item },
                react_1.default.createElement(FormatText_1.default, { id: item, uppercase: true }))); }))),
        react_1.default.createElement(antd_1.Col, { xs: 6, className: "ant-app-breadcrumb-actions" },
            workspaceToolbar,
            !!guide && (react_1.default.createElement(Button_1.default, { icon: "programming-help", responsive: true, onClick: toggleHelpAreaCollapse, className: helpAreaCollapsed ? 'ant-btn-link' : 'ant-btn-link active' },
                react_1.default.createElement(FormatText_1.default, { id: "ui.commons.help", uppercase: true }))))));
};
exports.default = BreadcrumbBar;
